/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response model for health endpoint.
 * @export
 * @interface HealthResponse
 */
export interface HealthResponse {
    /**
     * 
     * @type {string}
     * @memberof HealthResponse
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof HealthResponse
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof HealthResponse
     */
    environment: string;
    /**
     * 
     * @type {boolean}
     * @memberof HealthResponse
     */
    isDev: boolean;
}

/**
 * Check if a given object implements the HealthResponse interface.
 */
export function instanceOfHealthResponse(value: object): value is HealthResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('environment' in value) || value['environment'] === undefined) return false;
    if (!('isDev' in value) || value['isDev'] === undefined) return false;
    return true;
}

export function HealthResponseFromJSON(json: any): HealthResponse {
    return HealthResponseFromJSONTyped(json, false);
}

export function HealthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'version': json['version'],
        'environment': json['environment'],
        'isDev': json['is_dev'],
    };
}

export function HealthResponseToJSON(json: any): HealthResponse {
    return HealthResponseToJSONTyped(json, false);
}

export function HealthResponseToJSONTyped(value?: HealthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'version': value['version'],
        'environment': value['environment'],
        'is_dev': value['isDev'],
    };
}

